import "./Home.scss";
import React from "react";
import Hero from "./Hero";
import AboutCards from "./AboutCards";
import OfficialChannels from "./OfficialChannels";
import TourInfo from "./TourInfo";
import FinalCta from "./FinalCta";

const Home = () => {
  return (
    <main className="home">
      <Hero />
      <AboutCards />
      <OfficialChannels />
      {/* <TourInfo /> */}
      {/* <FinalCta /> */}
    </main>
  );
};

export default Home;